import React from 'react'
import PropTypes from 'prop-types'
import { Col, Row } from 'react-bootstrap'
import dynamic from 'next/dynamic'

import MyImage from '@shared/components/myImage'
import { getImgURL, numDifferentiation } from '@shared/utils'
import styles from '../teams/style.module.scss'
import teamPlaceholder from '@assets/images/placeholder/team-placeholder.jpg'
import AuctionPlayer from '../auctionPlayer'
import CustomLink from '@shared/components/customLink'

const Ads = dynamic(() => import('@shared/components/ads'))

export default function AuctionTeamDetail({ team, allTeam, category }) {
  return (
    <>
      <div className={`${styles.teamLinkList} mb-3 small-text d-flex overflow-auto`}>
        {allTeam?.map((e) => (
          <CustomLink
            key={e?._id}
            href={`/${e?.oSeo?.sSlug}/`}
            className={`${styles.item} ${team?._id === e?._id ? styles.active : ''} br-md`}
          >
            {e?.oTeam?.sAbbr} Squad
          </CustomLink>
        ))}
      </div>
      <div className={`${styles.team} br-lg overflow-hidden position-relative mb-3`} style={{ backgroundColor: `#${team?.sColorCode}` }}>
        <div className="d-flex flex-column flex-md-row align-items-md-center justify-content-between">
          <div className={`${styles.teamName} d-flex align-items-center big-text`}>
            <div className={`${styles.teamLogo} br-sm overflow-hidden`}>
              <MyImage
                src={team?.oTeam?.oImg?.sUrl ? getImgURL(team?.oTeam?.oImg?.sUrl) : teamPlaceholder}
                alt={team?.oTeam?.sAbbr || 'team'}
                width={120}
                height={120}
                sizes="(max-width: 768px) 40px"
              />
            </div>
            {team?.oTeam?.sTitle || team?.oTeam?.sAbbr}
          </div>
        </div>
        <div className={`${styles.info} ${styles.infoLage} d-flex align-items-center justify-content-around text-center`}>
          <div>
            <p className="mb-0">Total Players</p>
            <h4 className="fw-bold mb-0">{`${team.nPlayerCount}/${category?.oAuctionSeries?.oTeamOverView?.nTotalPlayersLimit || 25}`}</h4>
          </div>
          <div>
            <p className="mb-0">Overseas Players</p>
            <h4 className="fw-bold mb-0">{team.nOverseaPlayerCount}/{category?.oAuctionSeries?.oTeamOverView?.nTotalOverSeasPlayersLimit || 8}</h4>
          </div>
          <div>
            <p className="mb-0">Purse Spent</p>
            <h4 className="fw-bold mb-0">{numDifferentiation(team?.nTotalSpent)}</h4>
          </div>
          <div>
            <p className="mb-0">Purse Left</p>
            <h4 className="fw-bold mb-0">{numDifferentiation(team?.nPurseLeft)}</h4>
          </div>
        </div>
      </div>
      {team?.aBatterPlayer?.length > 0 && (
        <Row className="gx-3">
          <Col xs={12}>
            <h6 className={`${styles.secTitle} line-title mb-3 mb-md-4 text-uppercase overflow-hidden`}>
              <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Batters</span>
            </h6>
          </Col>
          {team?.aBatterPlayer?.map((player, index) => {
            return (
              <Col key={player?._id + index} lg={6} className="mb-3">
                <AuctionPlayer player={player} slug={category?.sSlug} />
                {team?.aBatterPlayer?.length > 3 && (index + 1) % 3 === 0 && (
                  <Ads
                    id={`div-aBatterPlayer-${index}-ad-mob-23148549803-1732886876-0`}
                    adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
                    dimensionDesktop={[320, 100]}
                    slotId="23148549803"
                    hideOn="desktop"
                    className={'text-center mt-3'}
                  />
                )}
              </Col>
            )
          })}
        </Row>
      )}
      {team?.aWicketKeeperPlayer?.length > 0 && (
        <Row className="gx-3">
          <Col xs={12}>
            <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
              <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Wicket Keepers</span>
            </h6>
          </Col>
          {team?.aWicketKeeperPlayer?.map((player, index) => {
            return (
              <Col key={player?._id + index} lg={6} className="mb-3">
                <AuctionPlayer player={player} slug={category?.sSlug} />
                {team?.aBatterPlayer?.length > 3 && (index + 1) % 3 === 0 && (
                  <Ads
                    id={`div-aWicketKeeperPlayer-${index}-ad-mob-23148549803-1732886876-0`}
                    adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
                    dimensionDesktop={[320, 100]}
                    slotId="23148549803"
                    hideOn="desktop"
                    className={'text-center mt-3'}
                  />
                )}
              </Col>
            )
          })}
        </Row>
      )}
      {team?.aAllRounderPlayer?.length > 0 && (
        <Row className="gx-3">
          <Col xs={12}>
            <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
              <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">All-Rounders</span>
            </h6>
          </Col>
          {team?.aAllRounderPlayer?.map((player, index) => {
            return (
              <Col key={player?._id + index} lg={6} className="mb-3">
                <AuctionPlayer player={player} slug={category?.sSlug} />
                {team?.aBatterPlayer?.length > 3 && (index + 1) % 3 === 0 && (
                  <Ads
                    id={`div-aAllRounderPlayer-${index}-ad-mob-23148549803-1732886876-0`}
                    adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
                    dimensionDesktop={[320, 100]}
                    slotId="23148549803"
                    hideOn="desktop"
                    className={'text-center mt-3'}
                  />
                )}
              </Col>
            )
          })}
        </Row>
      )}
      {team?.aBowlerPlayer?.length > 0 && (
        <Row className="gx-3">
          <Col xs={12}>
            <h6 className={`${styles.secTitle} line-title mb-3 mb-md-3 text-uppercase overflow-hidden`}>
              <span className="rounded-pill mx-1 px-2 px-xl-3 position-relative d-inline-block">Bowlers</span>
            </h6>
          </Col>
          {team?.aBowlerPlayer?.map((player, index) => {
            return (
              <Col key={player?._id + index} lg={6} className="mb-3">
                <AuctionPlayer player={player} slug={category?.sSlug} />
                {team?.aBatterPlayer?.length > 3 && (index + 1) % 3 === 0 && (
                  <Ads
                    id={`div-aBowlerPlayer-${index}-ad-mob-23148549803-1732886876-0`}
                    adIdDesktop="Crictracker_New_Mobile_SP_MID_320x100"
                    dimensionDesktop={[320, 100]}
                    slotId="23148549803"
                    hideOn="desktop"
                    className={'text-center mt-3'}
                  />
                )}
              </Col>
            )
          })}
        </Row>
      )}
    </>
  )
}
AuctionTeamDetail.propTypes = {
  team: PropTypes.object,
  allTeam: PropTypes.array,
  category: PropTypes.object
}
